import { jsx as _jsx } from "react/jsx-runtime";
import VantageLink from "../../../atoms/VantageLink";
export var stepLinksArray = [
    {
        annualCreditLink: (_jsx(VantageLink, { to: "//www.annualcreditreport.com", isExternal: true })),
    },
    // Second step has no links in it
    {},
    {
        transUnionLink: _jsx(VantageLink, { to: "//dispute.transunion.com", isExternal: true }),
        transUnionPhoneNumber: _jsx(VantageLink, { to: "tel:8009168800", isExternal: true }),
    },
];
export default stepLinksArray;
